import { Card, styled } from '@mui/material';

export default styled(Card)`
    margin-bottom: 8px;
    overflow: visible;
    padding: 48px 12px 40px;
`;
